import { Box, IconButton, Typography } from '@mui/material';
import { useLoadTheme } from '../../../../../config/loadThemeFromJson';
import configUrls from '../../../../../config/configUrls';
import { HeaderSiteRedeSocial } from '../../menuSite/HeaderSiteRedeSocial';

export function SiteRodape() {
  const theme = useLoadTheme();
  const logo = theme.custom?.logoBrasao || '';

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        backgroundColor: '#808080', // fundo cinza escuro
        borderTop: `3px solid #606060`,
        pt: 2,
        pb: 2,
        mt: 10,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center', // alinha verticalmente logo + texto
          gap: 2,
          textAlign: 'left'
        }}
      >
        {/* Logo */}
        <IconButton
          onClick={() => (window.location.href = configUrls.SITE_HOME)}
          title="Início"
          sx={{ p: 0 }}
        >
          <Box
            component="img"
            src={logo}
            alt="logo"
            sx={{
              width: 70,
              height: 'auto',
              display: 'block'
            }}
          />
        </IconButton>

        {/* Contato */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: '#FFFFFF' // texto branco para contraste
          }}
        >
          <Typography variant="subtitle1" fontWeight={700} sx={{ lineHeight: 1.2 }}>
            {theme.custom?.nome}
          </Typography>

          <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
            Endereço:{theme.custom?.endereco}
          </Typography>

          <Typography variant="body2" sx={{ mt: 0.3, lineHeight: 1.2 }}>
            Tel.:{theme.custom?.telefone} &nbsp; E-mail:  {theme.custom?.email}
          </Typography>

          <Box sx={{ mt: 1 }}>
            <HeaderSiteRedeSocial alignment="flex-end" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
